/*
  mm-countdown.js — cuenta atrás de la barra "mm-countdown".

  Reproduce el script inline de la tienda original: en modo "daily" calcula, con Intl.DateTimeFormat en la zona
  horaria data-tz, los segundos que faltan hasta la medianoche (86400 - segundos transcurridos del día) y vuelve a
  86400 cuando llega a cero, es decir, un temporizador que se reinicia cada día. En modo "fixed" cuenta hasta la
  fecha data-end ("AAAA-MM-DD HH:MM", interpretada en data-tz) y al terminar muestra ceros u oculta la barra
  (data-expired = zero | hide).

  Marcado esperado:
    <div class="mm-cd__clock" data-mm-countdown data-mode="daily|fixed" data-tz="America/Chicago"
         [data-end="2026-12-31 23:59" data-expired="zero|hide"]>
      [<span class="mm-cd__unit" data-unit="days" hidden><span data-d>00</span>…</span>]
      <span data-h>00</span> <span data-m>00</span> <span data-s>00</span>
*/
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Formateador de fecha en una zona horaria IANA; null si el navegador no la conoce.
  function makeFormatter(tz) {
    try {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    } catch (e) {
      return null;
    }
  }

  // Componentes de un instante vistos desde la zona horaria del formateador (o la del navegador).
  function partsOf(fmt, date) {
    if (fmt) {
      var p = {};
      fmt.formatToParts(date).forEach(function (part) {
        p[part.type] = parseInt(part.value, 10);
      });
      return { y: p.year, mo: p.month, d: p.day, h: p.hour % 24, m: p.minute, s: p.second };
    }
    return {
      y: date.getFullYear(),
      mo: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds(),
    };
  }

  // Modo diario: segundos hasta la medianoche de la zona (comportamiento de la tienda original).
  function secondsToMidnight(fmt) {
    var p = partsOf(fmt, new Date());
    var left = 86400 - (p.h * 3600 + p.m * 60 + p.s);
    return left <= 0 ? 86400 : left;
  }

  // Modo fijo: "AAAA-MM-DD HH:MM[:SS]" en la zona horaria → milisegundos UTC.
  function parseEnd(str, fmt) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(String(str || '').trim());
    if (!m) return NaN;
    var y = +m[1], mo = +m[2], d = +m[3], h = +(m[4] || 0), mi = +(m[5] || 0), s = +(m[6] || 0);
    if (!fmt) return new Date(y, mo - 1, d, h, mi, s).getTime();
    // Se parte del mismo "reloj de pared" en UTC y se corrige con el desfase que la zona tiene en ese instante
    // (dos pasadas para absorber los cambios de horario de verano).
    var guess = Date.UTC(y, mo - 1, d, h, mi, s);
    for (var i = 0; i < 2; i++) {
      var p = partsOf(fmt, new Date(guess));
      var asUtc = Date.UTC(p.y, p.mo - 1, p.d, p.h, p.m, p.s);
      guess += Date.UTC(y, mo - 1, d, h, mi, s) - asUtc;
    }
    return guess;
  }

  function init(clock) {
    if (clock.hasAttribute('data-mm-ready')) return;
    clock.setAttribute('data-mm-ready', '');

    var mode = clock.getAttribute('data-mode') || 'daily';
    var tz = clock.getAttribute('data-tz') || 'America/Chicago';
    var fmt = makeFormatter(tz);
    var dEl = clock.querySelector('[data-d]');
    var hEl = clock.querySelector('[data-h]');
    var mEl = clock.querySelector('[data-m]');
    var sEl = clock.querySelector('[data-s]');
    var daysUnit = clock.querySelector('[data-unit="days"]');
    var endAt = mode === 'fixed' ? parseEnd(clock.getAttribute('data-end'), fmt) : NaN;
    var timer = null;

    function render(left) {
      var days = Math.floor(left / 86400);
      var rest = left % 86400;
      if (dEl) dEl.textContent = pad(days);
      if (daysUnit) daysUnit.hidden = days === 0;
      if (hEl) hEl.textContent = pad(Math.floor(rest / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((rest % 3600) / 60));
      if (sEl) sEl.textContent = pad(rest % 60);
    }

    function tick() {
      if (mode === 'fixed') {
        if (isNaN(endAt)) {
          render(0);
          stop();
          return;
        }
        var left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
        render(left);
        if (left === 0) {
          stop();
          clock.setAttribute('data-mm-expired', '');
          if (clock.getAttribute('data-expired') === 'hide') {
            // .mm-cd lleva display:block en la hoja de estilos, así que el atributo hidden no basta.
            var bar = clock.closest('.mm-cd');
            if (bar) {
              bar.hidden = true;
              bar.style.display = 'none';
            }
            var wrapper = clock.closest('.shopify-section');
            if (wrapper) wrapper.style.display = 'none';
          }
        }
        return;
      }
      render(secondsToMidnight(fmt));
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var clocks = scope.querySelectorAll('[data-mm-countdown]');
    for (var i = 0; i < clocks.length; i++) init(clocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Editor de temas: las secciones se vuelven a insertar al cambiar ajustes.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
